import { useState } from 'react';
import { AppDocument } from 'api';
import Popover from '@mui/material/Popover';
import IconBtn from 'components/common/IconBtn';
import { DocStatus } from 'data/constants/DocStatus';
import { ReactComponent as EditIcon } from 'assets/icons/B2B/border_color.svg';
import ViewEditDocumentPopoverMenu from './ViewEditDocumentPopoverMenu';
import SelectDocStatusDropdown from './SelectDocStatusDropdown';
import * as S from './DocumentActionsPopover.styled';

type Props = {
    mobile: boolean;
    document: AppDocument;
    handleUpdateDoc: (document: AppDocument, title: string, explanation: string | null) => void;
    handleChangeStatus: (document: AppDocument, newDocStatus: DocStatus) => void;
};

const DocumentActionsPopover = ({
    mobile,
    document,
    handleUpdateDoc,
    handleChangeStatus,
}: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <S.BurgerMenu
                isActive={!!anchorEl}
                onClick={(event) => {
                    handleClick(event);
                }}
            >
                <IconBtn style={{ padding: '0px', width: '20px' }}>
                    <EditIcon fill="#282828" />
                </IconBtn>
            </S.BurgerMenu>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '170px',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <S.DropDownMenu>
                    <OptionItem margin={'1px'}>
                        <ViewEditDocumentPopoverMenu
                            icon={true}
                            mobile={mobile}
                            document={document}
                            handleUpdateDoc={handleUpdateDoc}
                            handleCloseActionsPopover={handleClose}
                        />
                    </OptionItem>
                    <OptionItem margin={'1px'}>
                        <SelectDocStatusDropdown
                            mobile={mobile}
                            document={document}
                            handleChangeStatus={handleChangeStatus}
                            actionsPopover={true}
                            handleCloseActionsPopover={handleClose}
                        />
                    </OptionItem>
                </S.DropDownMenu>
            </Popover>
        </>
    );
};

type OptionItemProps = {
    children: React.ReactNode;
    margin?: string;
};

const OptionItem = ({ children, margin }: OptionItemProps) => {
    return (
        <S.MenuItem>
            <S.Item margin={margin}>{children}</S.Item>
        </S.MenuItem>
    );
};
export default DocumentActionsPopover;
